/*
 * @description：心理咨询路由
 */
const baseUrl = '/hospital/mentalConsult';
const route = [
  {
    path: `${baseUrl}`,
    name: 'MentalConsultIntro',
    component: () => import(/* webpackPrefetchPlaceHolder */ './index'),
    auth: true,
    exact: true,
    title: '心理咨询',
  },
  {
    path: `${baseUrl}/form`,
    name: 'MentalConsultForm',
    component: () => import(/* webpackPrefetchPlaceHolder */ './form'),
    auth: true,
    exact: true,
    title: '咨询确认',
  },
];

export default route;

